<template>
    <el-drawer title="図面を送信する" size="450px" :visible.sync="visible" direction="rtl" :before-close="onClose">
        <div class="search-input">
            <el-input placeholder="内容を入力してください" v-model="searchInput" @keyup.enter.native="reload">
                <el-button slot="append" icon="el-icon-search" @click="reload"></el-button>
            </el-input>
        </div>

        <div class="pdf-list" v-loading="loading" element-loading-text="必死に読み込み中です">
            <div style="padding: 0 40px;height: 200px;display: flex;align-items: center;justify-content: center;flex-direction: column;"
                v-if="pdfList.length == 0">
                <img src="../../assets/image/empty.png" alt="" style="width:25%;">
                <div style="color: #8a8a8a; font-weight: bold;margin-top: 10px;">受注存在しません</div>
            </div>
            <div v-show="pdfList.length > 0">
                <div class="list-item" v-for="(item, index) in pdfList" :key="index">
                    <div class="pdf-text" @click="openInfo(item)">{{ item.zhuwen }}
                    </div>
                    <!-- <el-link class="pdf-text chat-file-name" :underline="false" target="_blank" type="primary"
                        :href="item.previewUrl">{{ item.pdfName }}</el-link> -->
                    <el-button slot="append" type="text" size="mini" @click="sendPdf(item)">図面を送信
                    </el-button>
                    <el-button slot="append" type="text" size="mini" @click="sendOrder(item)">注文を送信
                    </el-button>
                </div>
            </div>
        </div>
        <OrderInfo :centerDialogVisible="localVisible" @resetPopupData="cancelDialog" :orderInfo="orderInfo" />
    </el-drawer>
</template>

<script>
import axios from 'axios';
import micUrl from "../../../mic";
import OrderInfo from "./OrderInfo.vue";
export default {
    name: 'chatPdf',
    components: {
        OrderInfo
    },
    props: {
        visible: {
            type: Boolean
        }
    },
    data() {
        return {
            messages: [],
            loadAll: false,
            loading: false,
            // 搜索框
            searchInput: '',
            // 数据列表
            pdfList: [
                // {
                //     pdfName: '25A04936_6.pdf',
                //     url: 'https://dlxzzn.com/Miku/pdfhandle/szPdfDownLoad?code=25A04936&scode=6',
                // },
                // {
                //     pdfName: '25A04936_6.pdf',
                //     url: 'https://dlxzzn.com/Miku/pdfhandle/szPdfDownLoad?code=25A04936&scode=6'
                // }
            ],
            localVisible: false,
            orderInfo: {}
        }
    },
    methods: {
        onClose() {
            this.$emit('close');
        },
        // 查看pdf
        viewPdf(data) {
            let url = `https://dlxzzn.com/Miku/pdfhandle/szPdfDownLoadInline?code=${data.code}&scode=${data.childCode}`;
            return url;
        },
        // 发送pdf
        sendPdf(data) {
            let url = `https://dlxzzn.com/Miku/pdfhandle/szPdfDownLoad?code=${data.code}&scode=${data.childCode}`;
            data.url = url;
            this.$emit('sendPdf', data);
            this.$emit('close');
        },
        // 发送注文
        sendOrder(data) {
            console.log(micUrl, 'asdas')
            this.$emit('sendOrder', data);
            this.$emit('close');
        },
        // 打开订单详情
        openInfo(data) {
            this.orderInfo = data;
            this.localVisible = true;
        },
        cancelDialog() {
            this.localVisible = false;
        },
        reload() {
            try {
                this.loading = true;
                let mic = sessionStorage.getItem('mic');
                let scode
                mic == '1' ? scode = sessionStorage.getItem('scode') : null;
                // 加载数据
                new Promise((resolve, reject) => {
                    // axios.get('https://dlxzzn.com/Miku/pdfhandle/pdfInfoList', {
                    axios.get(`${micUrl}Miku/pdfhandle/pdfInfoList`, {
                        params: {
                            pageSize: 100,
                            pageNum: 1,
                            mic: mic,
                            supplierCode: mic == '1' ? scode : null,
                            code: this.searchInput,
                        },
                        // 携带token
                        headers: {
                            'Accesstoken': sessionStorage.getItem('accessToken')
                        }

                    }).then((res) => {
                        this.pdfList = res.data.rows;
                        this.loading = false;
                        resolve();
                    }).catch((err) => {
                        this.loading = false;
                        reject(err);
                    })
                })

            } catch (error) {
                this.loading = false;
                console.log(error);
            }

        }
    },
    computed: {

    },
    watch: {
        visible: {
            handler(newValue, oldValue) {
                if (newValue) {
                    // 打开抽屉时清空搜索框
                    this.searchInput = '';
                    // 打开抽屉时加载数据
                    this.reload();
                }
            }
        }
    }
}
</script>

<style lang="scss">
.v-modal {
    z-index: 1 !important;
}

.search-input {
    width: 100%;
    padding: 0 40px;
    margin-bottom: 5px;

    .el-input__inner {
        border: 1px solid #DCDFE6 !important;
    }
}

.pdf-list {
    height: 91%;
    overflow-y: auto;
    padding: 10px 40px;

    .list-item {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid #dcdfe6;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        justify-content: space-between;
        font-size: 15px;
        margin-bottom: 10px;

        .pdf-text {
            width: 60%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #2830d3;
            cursor: pointer;
        }

        .el-button {
            padding: 8px 0 !important;
        }
    }
}
</style>
